/* eslint-disable @atlaskit/platform/use-recommended-utils */
import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';
import { fg } from '@atlaskit/platform-feature-flags/fg';

/**
 * Products that support multi-site search. Kept as literals rather than importing a product-key
 * enum so that this stays usable from every search package.
 */
const MULTI_SITE_SEARCH_PRODUCTS = ['confluence', 'jira'];

/**
 * Whether multi-site search is enabled for the current session, i.e. whether a search may span more
 * than the current site.
 */
export const serveFpsMultiSiteSearchExperiment = ({
	primaryProduct,
	fireExperimentExposure = true,
}: {
	fireExperimentExposure?: boolean;
	primaryProduct?: string | null;
} = {}): boolean => {
	if (!primaryProduct || !MULTI_SITE_SEARCH_PRODUCTS.includes(primaryProduct)) {
		return false;
	}

	if (!fg('rovo_fps_enable_multi_site_search')) {
		return false;
	}

	return (
		FeatureGates.getExperimentValue<string>('rovo_fps_multi_site_search_exp', 'cohort', 'control', {
			fireExperimentExposure,
		}) === 'test'
	);
};

export const serveFpsMultiSiteSearchExperimentM2 = ({
	primaryProduct,
}: {
	primaryProduct?: string | null;
} = {}): boolean => {
	if (!primaryProduct || !MULTI_SITE_SEARCH_PRODUCTS.includes(primaryProduct)) {
		return false;
	}

	// The M2 experiment cohort check will be added once the experiment is configured.
	return fg('rovo_fps_enable_multi_site_search_m2');
};
